/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "0b8aff3b29a4737f6cd3565f90eadabe88fedf27";
